import { combineEpics } from 'redux-observable';

import { addCreativeEpics } from '../AddCreativePage/epics';
import { changePageEpic } from '../CanvasApp/epics';
import { commonCreativesEpics } from '../CommonCreatives/epics';
import { creativeImageCropModalEpics } from '../CreativeImageCropModal/epics';
import { creativeSmartCenterModalWrapperEpics } from '../CreativeSmartCenterModal/epics';
import { fileEditorEpics } from '../FileEditor/epics';
import { galleryEpics } from '../GalleryPane/epics';
import { ideasEpic } from '../IdeasList/epics';
import { loadPresetsEpic } from '../Presets/epics';
import { videoCreativesEpics } from '../VideoCreatives/epics';

export const canvasEpics = combineEpics(
    loadPresetsEpic,
    ideasEpic,
    commonCreativesEpics,
    videoCreativesEpics,
    addCreativeEpics,
    fileEditorEpics,
    galleryEpics,
    creativeImageCropModalEpics,
    creativeSmartCenterModalWrapperEpics,
    changePageEpic
);
